import { useQuery } from '@tanstack/react-query';
import { getChampById } from '../../api/CHAMPS/champs';

export const useGetChampById = (id) => {
  return useQuery({
    queryKey: ['champ', id],
    queryFn: () => getChampById(id),
    staleTime: 1000 * 60 * 10, // 10 minutes
    enabled: !!id,
  });
};
